import { render, staticRenderFns } from "./socialManage.vue?vue&type=template&id=941d9424&"
import script from "./socialManage.vue?vue&type=script&lang=js&"
export * from "./socialManage.vue?vue&type=script&lang=js&"
import style0 from "./socialManage.vue?vue&type=style&index=0&id=941d9424&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports